import { ShieldCheckIcon } from "@heroicons/react/outline"
import React from "react"
import config from "../lib/config"

export default function logo(props) {
  return (
    <div
      className={`h-8 md:h-10 w-auto flex items-center ${
        props.light ? "text-gray-400" : "text-default-600"
      }`}
    >
      <ShieldCheckIcon className="h-full w-auto mr-2 md:mr-3" />
      <h1 className="font-semibold text-xl md:text-2xl">{config.siteTitle}</h1>
    </div>
  )
}
